module.exports = __webpack_public_path__ + "static/icon-api-85972da3c96c14a531e165188e653633.svg";